export const SET_NOTI_MESSAGE = 'NOTIFICATION_SNACKBAR.SET_NOTI_MESSAGE';